import ActionTypes from './modalActionTypes';

export const hideModal = () => ({ type: ActionTypes.HIDE_MODAL });

export const openModal = (modalType, modalProps = {}, modalOptions = {}) => ({
  type: ActionTypes.OPEN_MODAL,
  payload: {
    modalType,
    modalProps,
    modalOptions,
  },
});

export const updateModalOptions = (modalOptions) => ({
  type: ActionTypes.UPDATE_MODAL_OPTIONS,
  payload: modalOptions,
});
